import axios from "axios";
import {toast} from 'react-toastify'
import { COMPANY_LIST_URL } from "../config/links.js";

export const FETCH_COMPANIES = 'FETCH_COMPANIES'
export const RECEIVE_COMPANIES = 'RECEIVE_COMPANIES'
export const FAILED_COMPANIES = 'FAILED_COMPANIES'

export function fetchCompanies(){
    return (dispatch, getState) => {
        let auth = getState().authStore.authData.result.token;
        dispatch({type: FETCH_COMPANIES});
        axios({
            method: 'post',
            url: COMPANY_LIST_URL,
            headers: {
                Authorization: auth
            },
            // data: {
            //     dev: 'T02',
            //     // date: 
            //     // For Parameters
            // }
        })
        .then((response) => {
            // console.log(response.data)
            dispatch( {
                type: RECEIVE_COMPANIES,
                payload: response.data
            })
            // console.log(response.data)
        })
        .catch(function(error){
            if (error.response) {
                if(error.response.status === 401) {
                    dispatch({
                        type: FAILED_COMPANIES
                    })
                    return toast.error('Unathorized access!');
                } else if (error.response.status === 404 || error.response.status === 500) {
                    dispatch({
                        type: FAILED_COMPANIES
                    })
                    return toast.error("Server cannot be contacted! Please ask your system administrator!");
                } else if (error.response.status === 400) {
                    dispatch({
                        type: FAILED_COMPANIES
                    })
                    return toast.error(error.response.data.message);
                } else {
                    dispatch({
                        type: FAILED_COMPANIES
                    })
                    return toast.error('Something went wrong... Please try again later...');
                }
            } else if (error.request) {
                dispatch({
                    type: FAILED_COMPANIES
                })
                return toast.error("Something went wrong!... Please try again later.");
            } else {
                dispatch({
                    type: FAILED_COMPANIES
                })
                return toast.error("Something went wrong!... Please try again later.");
            }

        })
    }
}